<template>
    <div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }"> <!-- Aqui solução do layout! -->

      <h1>Cadastro de Advogados</h1>

      <div>
        <div class="col-md-12 card" v-show="cadastramento_sem_certificado_digital">
            <div class="card-body">
                <div class="row text-md-left">
                    <div class="col-lg-12">
                        <p id="pComCert">O cadastramento com certificado digital dispensa a validação pessoal, não requerendo comparecimento ao(à) Justiça Estadual.</p>
                        <div class="d-flex text-right justify-content-end">
                            <button type="button" acesskey="C" id="btnCadastroComCert"
                                    name="cadastroComCert" class="btn btn-sm btn-primary"
                                    value="Cadastro com certificado digital"
                                    style="margin-right: 5px;" @click="showToast('Em desenvolvimento.')">
                                Cadastro com certificado digital
                            </button>
                            <div class="dropdown ml-2">
                              <a href="#" id="dropdownMenuButton" data-toggle="dropdown" data-bs-toggle="dropdown" aria-label="Ajuda" class="btn btn-sm btn-light dropdown-toggle">Ajuda</a>
                                                <div class="dropdown-menu">
                                                    <a class="dropdown-item" href="#">Saiba como obter certificado digital</a>
                                                    <a class="dropdown-item" href="#">Problemas de acesso com certificado?</a>
                                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div class="col-md-12 card mt-5" v-show="cadastramento_com_certificado_digital">
            <div class="card-body">
                <div class="row text-lg-left">
                    <div class="col-lg-12">
                        <p id="pSemCert">O cadastramento sem uso de certificado digital requer o seu comparecimento ao(à) Justiça Estadual para ativar seu cadastro.</p>
                        <div style="text-align: right;">
                            <button type="button" class="btn btn-sm btn-primary"  @click="AbrirCadSemCertificado">
                                Cadastro sem certificado digital
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>

      <div class="col-md-12 card mt-5" v-show="mostrar_pre_cadastro">
            <div class="card-body">
                <div class="row text-lg-left">
                    <div class="col-lg-12">
                        <p><strong>Informe sua OAB e CPF:</strong></p>
                        <div class="container mt-5">
                            <div class="row">
                                <!-- Campo OAB -->
                                <div class="col-md-2">
                                    <div class="form-group">
                                    <label for="estado">OAB:</label>
                                    
                                    <select class="form-control" id="estado" v-model="selectedEstado">
                                        <option value="" disabled selected>UF</option>
                                        <option v-for="(estado, sigla) in estados" :key="sigla" :value="sigla">{{ estado.sigla }}</option>
                                    </select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                    <label for="oabNumero">&nbsp;</label>
                                    <input type="text" class="form-control" id="oabNumero" maxlength="6" placeholder="Número da OAB" v-model="dados.oab">
                                    </div>
                                </div>
                                
                                <!-- Campo CPF -->
                                <div class="col-md-6">
                                    <div class="form-group">
                                    <label for="cpf">CPF:</label>
                                    <input type="text" class="form-control" id="cpf" placeholder="Número do CPF" v-model="dados.cpf" maxlength="15" required v-mask="'###.###.###-##'">
                                    </div>
                                </div>

                            <div class="col-md-12">
                                <br />
                                <p><strong>Insira o código a seguir na caixa de texto:</strong></p>

                            </div>
                            <div class="col-12">
                                <img :src="caminhoImagemAleatoria.src" :alt="caminhoImagemAleatoria.alt" :data-id="caminhoImagemAleatoria.description">
                                <img src="imagens/captcha/icone_ouvir.jpg" alt="" /><br />
                                <input type="text" class="form-control" id="recaptcha_digitado" style="width: 120px; margin-top: 2px;" v-model="recaptcha_digitado" ref="recaptcha_digitado">

                            </div>
                            <div class="col-12" style="text-align: right;">
                                <button type="button" class="btn btn-sm btn-primary" style="margin-right: 2px;" @click="MostrarCadastroTotal();"><u>O</u>K</button>
                                <button type="button" class="btn btn-sm btn-light" @click="FecharCadSemCertificado();"><u>V</u>oltar</button>
                            </div>
                            <div class="col-12">
                                <hr />
                            </div>
                            <div class="col-12">
                                <div class="alert alert-info mt-3">
                                    <h6 class="font-weight-bold">Atenção:</h6>
                                        <span>Esse cadastro é exclusivo para ADVOGADOS com registro definitivo na Ordem
                                        dos Advogados do Brasil.<br>
                                        O login do Advogado terá o seguinte padrão: UF999999. <br>Ex: RS004354.<br><br>
                                    </span>
                                        <span>Clique <a id="alink" href="http://www.youtube.com/watch?v=b3USf9XyUpE" target="_blank">
                                            aqui</a> para acessar o tutorial em vídeo.
                                    </span>
                                    <hr />
                                    
                                    <h6 class="font-weight-bold" style="font-size: small;">Atenção:</h6>
                                        <span style="font-size: small;">Para o bom uso deste simulador sugerimos que a informação cadastrada seja o registro acadêmico da sua instituição. Caso ele possua mais de 6 digitos, digite apenas os 6 primeiros, mantendo uma simulação de registro de OAB conforme o exemplo <strong>RS004354</strong>.<br><br>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>



        <div class="col-md-12 mt-5 mb-5" v-show="mostrar_cadastro_total">
                <div class="row text-lg-left">
                    <div class="col-lg-12">
                        <form @submit.prevent="GravarAdvogado">
                            <div style="text-align: right; width: 100%;">
                                <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px;" @click="FecharCadSemCertificado();">
                                    <u>V</u>oltar
                                </button>
                                <button type="button" class="btn btn-sm btn-light" @click="GravarAdvogado();" style="margin-right: 2px; width: 150px;" :disabled="btnSalvar">
                                    <u>S</u>alvar
                                </button>
                            </div>
                            <div class="mb-3">
                                <h6>OAB:</h6>
                                <label for="nome" class="form-label">{{selectedEstado}}{{ oab }} Nome:</label>
                                <input type="text" class="form-control" id="nome" v-model="dados.nome" required>
                            </div>

                            <div class="mb-3">
                                <label for="sexo" class="form-label">Sexo:</label>
                                <select class="form-select" id="sexo" v-model="dados.sexo">
                                <option value="masculino">Masculino</option>
                                <option value="feminino">Feminino</option>
                                <option value="outro">Outro</option>
                                </select>
                            </div>

                            <div class="mb-3">
                                <label for="estadoCivil" class="form-label">Estado Civil:</label>
                                <select class="form-select" id="estadoCivil" v-model="dados.estado_civil">
                                <option value="solteiro">Solteiro(a)</option>
                                <option value="casado">Casado(a)</option>
                                <option value="divorciado">Divorciado(a)</option>
                                <option value="viuvo">Viúvo(a)</option>
                                </select>
                            </div>

                            <div class="mb-3">
                                <label for="dataNascimento" class="form-label">Data de Nascimento:</label>
                                <input type="date" class="form-control" id="dataNascimento" v-model="dados.data_nascimento">
                            </div>

                            <div class="mb-3">
                                <label for="nacionalidade" class="form-label"><img src="imagens/icons/icone_calendario.jpg" />Nacionalidade:</label>
                                <select class="form-select" id="nacionalidade" v-model="dados.nacionalidade">
                                <option v-for="pais in paises" :key="pais.sigla" :value="pais.sigla">
                                    {{ pais.gentilico }}
                                </option>
                                </select>
                            </div>

                            <div class="mb-3">
                                <label for="cpf_cadastro_geral" class="form-label">CPF:</label>
                                <input type="text" class="form-control" id="cpf_cadastro_geral" disabled v-model="cpf_cadastro_geral" required v-mask="'###.###.###-##'">
                            </div>

                            <div class="mb-3">
                                <label for="identidadeCivil" class="form-label">Identidade Ci<u>v</u>il (RG, CNH, Cert. Nasc.):</label>
                                <input type="text" class="form-control" id="identidade_civil" v-model="dados.identidade_civil">
                            </div>

                            <div class="mb-3">
                                <label for="orgao_expedidor" class="form-label">Órgão Expedidor:</label>
                                <input type="text" class="form-control" id="orgao_expedidor" v-model="dados.orgao_expedidor">
                            </div>

                            <div class="mb-3">
                                <label for="data_emissao" class="form-label">Data de Emissão:</label>
                                <input type="date" class="form-control" id="data_emissao" v-model="dados.data_emissao">
                            </div>

                            <div class="mb-3">
                                <label for="nome_mae" class="form-label">Nome Mãe:</label>
                                <input type="text" class="form-control" id="nome_mae" v-model="dados.nome_mae">
                            </div>

                            <div class="mb-3">
                                <label for="nome_pai" class="form-label">Nome Pai:</label>
                                <input type="text" class="form-control" id="nome_pai" v-model="dados.nome_pai">
                            </div>


                            <div class="mb-3">
                                <label for="endereco" class="form-label">Endereço Logradouro:</label>
                                <input type="text" class="form-control" id="endereco" v-model="dados.endereco">
                            </div>

                            <div class="mb-3">
                                <label for="endereco_numero" class="form-label">Número:</label>
                                <input type="text" class="form-control" id="endereco_numero" v-model="dados.numero">
                            </div>

                            <div class="mb-3">
                                <label for="bairro" class="form-label">Bairro:</label>
                                <input type="text" class="form-control" id="bairro" v-model="dados.bairro">
                            </div>

                            <div class="mb-3">
                                <label for="pais" class="form-label">P<u>a</u>ís:</label>
                                <select class="form-select" id="pais" v-model="dados.pais">
                                <option v-for="pais in paises" :key="pais.sigla" :value="pais.sigla">
                                    {{ pais.nome_pais }}
                                </option>
                                </select>
                            </div>

                            <div class="mb-3">
                                <label for="uf" class="form-label"><u>U</u>F:</label>
                                <select class="form-control" id="estado" v-model="dados.uf">
                                    <option v-for="(estado, sigla) in estados" :key="sigla" :value="sigla">{{ estado.sigla }}</option>
                                </select>
                            </div>

                            <div class="mb-3">
                                <label for="Localidade" class="form-label">Locali<u>d</u>ade:</label>
                                <input type="text" class="form-control" id="localidade" v-model="dados.localidade">
                            </div>

                            <div class="mb-3">
                                <label for="Telefone" class="form-label"><u>T</u>elefone:</label>
                                <input type="text" class="form-control" id="telefone" v-model="dados.telefone" maxlength="15">
                            </div>

                            <div class="mb-3">
                                <label for="email" class="form-label">E-M<u>a</u>il:</label>
                                <input type="email" class="form-control" id="email" v-model="dados.email" required>
                            </div>

                            <div class="mb-3">
                                <label for="receber_info" class="form-label"><u>R</u>eceber informações de prazos por email:&nbsp;&nbsp;</label>
                                <label>
                                    <input type="radio" v-model="dados.receber_informacao_prazos_email" value="1" selected>&nbsp;Sim&nbsp;
                                </label>
                                <label>
                                    <input type="radio" v-model="dados.receber_informacao_prazos_email" value="0">&nbsp;Não&nbsp;
                                </label>
                            </div>

                            <div class="mb-3">
                                <label for="receber_esquecimento" class="form-label"><u>U</u>sar email para esquecimento de senha? :&nbsp;&nbsp;</label>
                                <label>
                                    <input type="radio" v-model="dados.usar_email_esquecimento_senha" value="1" selected>&nbsp;Sim&nbsp;
                                </label>
                                <label>
                                    <input type="radio" v-model="dados.usar_email_esquecimento_senha" value="0">&nbsp;Não&nbsp;
                                </label>
                            </div>

                            <div class="mb-3">
                                <label for="receber_distribuicap" class="form-label"><u>R</u>eceber informações da distribuição por email?:&nbsp;&nbsp;</label>
                                <label>
                                    <input type="radio" v-model="dados.receber_informacao_distribuicao_email" value="1" selected>&nbsp;Sim&nbsp;
                                </label>
                                <label>
                                    <input type="radio" v-model="dados.receber_informacao_distribuicao_email" value="0">&nbsp;Não&nbsp;
                                </label>
                            </div>

                            <div class="mb-3">
                                <p class="font-weight-bold" style="font-size: small; background-color: lightgray;">
                                    <label style="color: red;"><strong>Atenção</strong></label><br />
                                Senhores Advogados:<br />O email não dispensa a consulta eletrônica para fins de intimação e citação (art. 5º da Lei nº 11.419/2006).
                                </p>
                            </div>

                            <br />

                            <div class="mb-3">
                                <p class="font-weight-bold" style="font-size: small; background-color: lightgray;">
                                    <label style="color: red;"><strong>Atenção 2</strong></label><br />
                                As informações até aqui inseridas são idênticas ao sistema do eproc oficial. Os próximos campos são de uso exclusivo deste simulador.
                                </p>
                            </div>

                            <div class="mb-3">
                                <label for="registro_academico" class="form-label"><u>R</u>A (Registro Acadêmico):</label>
                                <input type="text" class="form-control" id="registro_academico" v-model="dados.registro_academico">
                            </div>

                            <div class="mb-3">
                                <label for="senha" class="form-label"><u>S</u>enha de acesso ao simulador:</label>
                                <input type="password" class="form-control" id="senha" v-model="dados.senha" required>
                            </div>

                            <div class="mb-3">
                                <label for="comunicacoes_twm" class="form-label">Aceito receber outras comunicações da TWM Simuladores e seus parceiros, como podcast, palestras e eventos relacionados a área do Direito.&nbsp;&nbsp;</label><br />
                                <label>
                                    <input type="radio" v-model="dados.aceita_receber_comunicacoes" value="1" selected>&nbsp;Sim&nbsp;
                                </label>
                                <label>
                                    <input type="radio" v-model="dados.aceita_receber_comunicacoes" value="0">&nbsp;Não&nbsp;
                                </label>
                            </div>

                            <div class="mb-3">
                                <label for="receber_distribuicap" class="form-label">Estou de acordo de conceder meus dados para uso exclusivo deste simulador.&nbsp;&nbsp;</label><br />
                                <label>
                                    <input type="radio" v-model="dados.aceita_uso_dados_simulador" value="1" selected @change="verificarAceiteTermos">&nbsp;Sim&nbsp;
                                </label>
                                <label>
                                    <input type="radio" v-model="dados.aceita_uso_dados_simulador" value="0" @change="verificarAceiteTermos">&nbsp;Não&nbsp;
                                </label>
                                <br />
                                <span v-if="exibirAceite" style="color: red; font-size: small;">É necessário estar de acordo para efetivar o cadastro.</span>
                            </div>

                            <div style="text-align: right; width: 100%;" class="mb-5">
                                <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px;" @click="FecharCadSemCertificado();">
                                    <u>V</u>oltar
                                </button>
                                <button type="button" class="btn btn-sm btn-light" @click="GravarAdvogado();" style="margin-right: 2px; width: 150px;" :disabled="btnSalvar">
                                    <u>S</u>alvar
                                </button>
                            </div>

                        </form>
                    </div>
                </div>
        </div>




    </div>
  </template>
  
  <script>
    import Toastify from 'toastify-js';
    import 'toastify-js/src/toastify.css';

    import axios from 'axios';
    const baseUrl = window.Laravel.baseUrl;

  export default {
        name: 'RegisterPage',
        data() {
            return {
                //Variaveis de definição do sistema
                cadastramento_sem_certificado_digital: true,
                cadastramento_com_certificado_digital: true,
                mostrar_pre_cadastro: false,
                mostrar_cadastro_total: false,
                estados: {},
                imagens_captcha: [
                    { id: 1, src: "imagens/captcha/6WGF.jpg", alt: "6WGF", description: "6WGF" },
                    { id: 2, src: "imagens/captcha/FUNM.jpg", alt: "FUNM", description: "FUNM" },
                    { id: 3, src: "imagens/captcha/KTPO.jpg", alt: "KTPO", description: "KTPO" },
                    { id: 3, src: "imagens/captcha/L9CB.jpg", alt: "L9CB", description: "L9CB" },
                    { id: 3, src: "imagens/captcha/O9DD.jpg", alt: "O9DD", description: "O9DD" },
                    { id: 3, src: "imagens/captcha/RHMM.jpg", alt: "rhmm", description: "rhmm" },
                ],
                caminhoImagemAleatoria: {},
                btnSalvar: false,
                exibirAceite: false,
                //Até aqui variaveis de definição do sistema.

                //A partir daqui, variáveis dos campos de pré-cadastro
                selectedEstado: '',
                oab: '',
                cpf: '',
                cpfValido: true,
                recaptcha_digitado: '',
                //Fim das variaveis do pré-cadastro

                //Variáveis  do cadastro do advogado
                cpf_cadastro_geral: '',
                dados: {
                    nome:'',
                    oab: '',
                    cpf: '',
                    sexo: '',
                    estado_civil: '',
                    data_nascimento: '',
                    nacionalidade: 'BR', // Defina o valor inicial brasileiro como padrão
                    identidade_civil: '',
                    orgao_expedidor: '',
                    data_emissao: '',
                    nome_mae: '',
                    nome_pai: '',
                    endereco: '',
                    numero: '',
                    complemento: '',
                    bairro: '',
                    cep: '',
                    pais: '',
                    uf: '',
                    localidade: '',
                    telefone: '',
                    email: '',
                    receber_informacao_prazos_email: '1',
                    usar_email_esquecimento_senha: '1',
                    receber_informacao_distribuicao_email: '1',

                    registro_academico: '',

                    aceita_receber_comunicacoes: '1',
                    aceita_uso_dados_simulador: '1',
                    senha: '',
                },
                paises: [],
                //Fim das variaveis do cadastro do advogado
            };
        },
        methods: {
            showToast(message) {
                const toast = Toastify({
                    text: `${message}`,
                    duration: 3000,
                    gravity: 'top',
                    position: 'right', // Mudança para o canto superior direito
                    stopOnFocus: true,
                    style: {
                        background: "linear-gradient(to right, black, darkorange)",
                    }
                });

                toast.showToast();
            },

            //Métodos iniciais de configuração da tela e visualização dos componentes
            carregarEstados() {
                fetch(baseUrl + 'common/cidades.json')
                    .then(response => response.json())
                    .then(data => {
                    this.estados = data;
                    })
                    .catch(error => {
                    console.error('Erro ao carregar estados:', error);
                    });
            },
            AbrirCadSemCertificado(){
                this.mostrar_pre_cadastro = true;
                this.cadastramento_com_certificado_digital = false;
                this.cadastramento_sem_certificado_digital = false;
            },
            FecharCadSemCertificado(){
                this.mostrar_pre_cadastro = false;
                this.cadastramento_com_certificado_digital = true;
                this.cadastramento_sem_certificado_digital = true;
                this.mostrar_cadastro_total = false;

            },
            selecionarImagemAleatoria() {
                const indiceAleatorio = Math.floor(Math.random() * this.imagens_captcha.length);
                this.caminhoImagemAleatoria = this.imagens_captcha[indiceAleatorio];
            },
            MostrarCadastroTotal(){
                if (this.selectedEstado === '') {
                    alert('Campo estado deve ser selecionado.');
                    return;
                }

                if (this.dados.oab === '') {
                    alert('A OAB deve ser composta pela sigla da UF (Unidade Federativa) e pelo menos um número.');
                    return;
                }

                if (this.dados.cpf === '') {
                    alert('CPF inválido');
                    return;
                }
                
                if (this.recaptcha_digitado === '') {
                    alert('Informe o código de confirmação');
                    this.$refs.recaptcha_digitado.focus();
                    return;
                }
                
                if (this.caminhoImagemAleatoria.description != this.recaptcha_digitado) {
                    alert('Código da imagem (captcha) incorreto.');
                    return;
                }
                this.mostrar_pre_cadastro = false;
                this.mostrar_cadastro_total = true;
                this.cpf_cadastro_geral = this.dados.cpf;
                this.oab = this.dados.oab;
            },
            //Fim dos métodos iniciais de configuração da tela e visualização dos componentes

            //Metodos do cadastro do Advogado

            CarregarPaises(){
                fetch(baseUrl + 'common/nacionalidades.json')
                    .then(response => response.json())
                    .then(data => {
                        this.paises = data;
                    })
                    .catch(error => console.error('Erro ao carregar países:', error));
                
            },

            verificarAceiteTermos(){
                this.btnSalvar = this.dados.aceita_uso_dados_simulador === '0';
                this.exibirAceite = this.dados.aceita_uso_dados_simulador === '0';
            },

            Validacoes(){

                if(this.dados.nome === ''){
                    alert('Campo nome não pode ser vazio.');
                    return false;
                }

                if(this.dados.email === ''){
                    alert('Campo email não pode ser vazio.');
                    return false;
                }

                if(this.dados.senha === ''){
                    alert('Campo senha não pode ser vazio.');
                    return false;
                }

                return true;
            },

            GravarAdvogado(){
                
                /* Validações */
                if(!this.Validacoes()){
                    //Se não passar pelas validacoes, para a função
                    return;
                }

                axios.post(baseUrl + 'advogado_cadastrar', this.dados)
                    .then(response => {
                        alert(response.data.message);
                        // Adicione lógica adicional após a autenticação bem-sucedida
                        window.location.href = baseUrl + 'login';

                    })
                    .catch(error => {
                        console.log('Caiu no catch: ' + error.message);

                        // Se houver erros de validação, exiba as mensagens para o usuário
                        if (error.response && error.response.status === 422) {
                            const validationErrors = error.response.data.errors;

                            // Exiba as mensagens de erro para o usuário
                            for (const field in validationErrors) {
                                console.error(`Erro no campo ${field}: ${validationErrors[field][0]}`);

                                if(field == 'email')
                                {
                                    alert("Cadastro não efetivado. E-mail já cadastro. Utilize a opção 'Esqueci minha senha' da tela de login.");
                                    return;
                                }
                            }
                        } else if (error.response && error.response.status === 409) {
                            // Caso específico: E-mail já cadastrado
                            alert('O e-mail já está cadastrado.');
                        } else {
                            // Outros casos de erro, exibir uma mensagem genérica ou tomar ação apropriada
                            console.error('Erro inesperado:', error.message);
                        }
                    });
            },
            //Fim dos metódos do cadastro do Advogado


        },
        mounted() {
            //Métodos iniciais de configuração da tela e visualização dos componentes
            this.carregarEstados();
            this.selectedEstado = "RS";
            this.selecionarImagemAleatoria();
            //Fim dos métodos iniciais de configuração da tela e visualização dos componentes

            //A partir daqui variaveis do cadastro do Advogado
            //Paises para o drop da nacionalidade
            this.CarregarPaises();

            //Fim das variaveis do cadastro do Advogado
        },


  };
  </script>
  
<style scoped>
.btn-primary {
    background-color: #007ebd;
}

/* Cor do botão no hover (escurecido) */
.btn-primary:hover {
    background-color: #005e94; /* Ajuste o valor percentual conforme necessário */
}

.btn-light{
    color: rgb(62, 136, 227); 
    border: solid 1px lightgray;
}

button u {
  text-decoration: underline;
}

  </style>
  
